import { Avatar, Box, Grid2, TextField, Stack, Typography, useTheme } from "@mui/material";
import { useState } from "react";

export function ContactEditorForm({...params}) {
    let input = params.input
    let handleInput = params.handleInput
    let [inputFocusState, setInputFocusState] = useState('')

    const theme = useTheme();

    const getInitials = (name) => {
        if (!name) return "";
        else return name.split(" ").map((word) => word[0]).join("").toUpperCase()
    };


    //LabelCell renders a label in a grid cell for a form field
    const LabelCell = ({ label, theme }) => (
        <Grid2 display={'flex'} alignItems={'center'} justifyContent={'flex-end'} height={'50px'} width={'155px'} padding={'20px 7px'} sx={{backgroundColor: theme.palette.ContactEditor.textFieldFilled}}>
            <Typography fontWeight="bold" fontSize={'18px'}>{label}</Typography>
        </Grid2> 
    );

    
    function nameToColor(name) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < name.length; i += 1) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }


    let formBoxTop = ''
    if (input.name === '') formBoxTop = '143px'
    else if (input.name !== '') formBoxTop = '105px'

    return (
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} width={"100%"} maxWidth={'512px'} height={"179px"} gap={3} id={"contentEditorFormBox"}
            position={'absolute'} sx={{top:formBoxTop}}
        >

            {(input.name !== '') && (
                <Box display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"center"} height={'74px'} width={'512px'} gap={"10px"} id={"nameEmailAvatarBox"}>
                    <Avatar sx={{ width: 40, height: 40, bgcolor: nameToColor(input.name), color: "#FFFFFF" }}>
                        {getInitials(input.name)}
                    </Avatar>
                    <Box id="nameEmailBox" display="flex" flexDirection="column">
                        <Typography fontSize="18px">{input.name}</Typography>
                        <Typography fontSize="18px">{input.email}</Typography>
                    </Box>
                </Box>
            )}
            
            <Grid2 id="contactEditorFormFields" container spacing={0.5}>
                <Stack direction={'row'} spacing={0.5} width={'512px'}>
                    <LabelCell label="Full Name" theme={theme}/>
                    <Grid2 alignContent={'center'} height={'50px'} width={'354px'} padding={'3px'} backgroundColor={theme.palette.ContactEditor.textFieldFilled}>
                        <TextField
                            value={input.name}
                            onFocus={() => setInputFocusState('name')}
                            onChange={(event) => handleInput(event, 'name')}
                            placeholder={"Enter Full Name"}
                            variant="filled"
                            slotProps={{ input: { disableUnderline: true} }}
                            sx={{
                                '& .MuiInputBase-input': {padding: '0px', fontSize:'18px'},
                                '& .MuiFilledInput-root': {height: '44px', width: '346px'},
                                '& .MuiFilledInput-input': {
                                    backgroundColor: (inputFocusState === 'name') ? '#000000' : theme.palette.ContactEditor.textFieldFilled,
                                    border: (inputFocusState === 'name') ? '3px solid #75BCFA' : '1px solid ' + theme.palette.ContactEditor.textFieldFilled,
                                    height: '44px',
                                },
                            }}
                        />
                    </Grid2>
                </Stack>

                <Stack direction={'row'} spacing={0.5} width={'512px'}>            
                    <LabelCell label="Email Address" theme={theme}/>
                    <Grid2 alignContent={'center'} height={'50px'} width={'354px'} padding={'3px'} backgroundColor={theme.palette.ContactEditor.textFieldFilled}>
                        <TextField
                            value={input.email}
                            onFocus={() => setInputFocusState('email')}
                            onChange={(event) => handleInput(event, 'email')}
                            placeholder={"Enter Email Address"}
                            variant="filled"
                            slotProps={{ input: { disableUnderline: true} }}
                            sx={{
                                '& .MuiInputBase-input': {padding: '0px', fontSize:'18px'},
                                '& .MuiFilledInput-root': {height: '44px', width: '346px'},
                                '& .MuiFilledInput-input': {
                                    backgroundColor: (inputFocusState === 'email') ? '#000000' : theme.palette.ContactEditor.textFieldFilled,
                                    border: (inputFocusState === 'email') ? '3px solid #75BCFA' : '1px solid ' + theme.palette.ContactEditor.textFieldFilled,
                                    height: '44px',
                                },
                            }}
                        />
                    </Grid2>
                </Stack>    
            </Grid2>
        </Box>
    )
}
